var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('model-data-table',_vm._b({ref:"table",attrs:{"loading-text":"Cargando facturas de compra...","no-data-text":"Sin facturas de compra.","no-remove":"","no-search":""},on:{"detail":_vm.submitDetail}},'model-data-table',_vm.tableProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }